module.exports = __webpack_public_path__ + "img/france-tuberculosis-male.a531215d.png";